// HearthVault logo marks — hand-drawn SVG, currentColor so they work on any background.
// A: Hearth Arch — fireplace arch with a keyhole; the home and the lock in one shape.
// B: Ember Key — a flame whose base is a key bit; warmth that unlocks.
// C: Hearthstone — rounded stone with a hearth flame and hearthstone base; monogram-friendly.

export const MarkHearthArch = ({ className = "h-8 w-8", title = "HearthVault" }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label={title} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 56V30C10 17.85 19.85 8 32 8s22 9.85 22 22v26" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
    <path d="M6 56h52" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
    <circle cx="32" cy="31" r="6.5" fill="currentColor" />
    <path d="M29.5 35.5h5L37 48H27l2.5-12.5Z" fill="currentColor" />
  </svg>
);

export const MarkEmberKey = ({ className = "h-8 w-8", title = "HearthVault" }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label={title} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 6c3 8 12 12 12 22a12 12 0 0 1-24 0c0-5 3-8 5-10 0 5 3 7 5 7-1-6 0-13 2-19Z" fill="currentColor" />
    <path d="M32 40v18" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
    <path d="M32 47h9M32 55h6" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
  </svg>
);

export const MarkHearthstone = ({ className = "h-8 w-8", title = "HearthVault" }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label={title} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 4 56 14v18c0 14-10 23-24 28C18 55 8 46 8 32V14L32 4Z" stroke="currentColor" strokeWidth="5" strokeLinejoin="round" />
    <path d="M32 20c2 5 8 8 8 14a8 8 0 0 1-16 0c0-3 2-5 3-6 0 3 2 4 3 4-1-4 0-8 2-12Z" fill="currentColor" />
    <path d="M22 46h20" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
  </svg>
);

export const MARKS = {
  arch: { id: "arch", name: "Hearth Arch", Mark: MarkHearthArch, idea: "The fireplace arch is the home; the keyhole is the vault. One shape, two promises: warmth and security." },
  ember: { id: "ember", name: "Ember Key", Mark: MarkEmberKey, idea: "A flame that becomes a key — the family's warmth is what unlocks everything when it's needed." },
  stone: { id: "stone", name: "Hearthstone", Mark: MarkHearthstone, idea: "A shield-shaped hearthstone with the fire kept inside. Reads as protection first, home second." },
};

export const TAGLINES = [
  { id: "kept", text: "Every paper kept. Every plan ready.", why: "Names both halves of the app — the AI-filed vault and the estate/handoff side — in six words." },
  { id: "remembers", text: "The family safe that remembers.", why: "Leans on the reminders, digests and Ask-your-vault memory; warm and slightly human." },
  { id: "handed", text: "Kept safe. Kept current. Handed on.", why: "Three beats: storage, smart reminders, executor handoff. Works as a footer line or on the signing sheet." },
  { id: "quiet", text: "Quietly organized for the moment it matters.", why: "Matches the current hero voice ('quietly organized by AI') and the break-glass promise." },
  { id: "current", text: "The family document safe", why: "The previous line, kept for reference." },
];
